import { render, staticRenderFns } from "./leave-case-manage-handled.vue?vue&type=template&id=3b6ddee8&scoped=true"
import script from "./leave-case-manage-handled.vue?vue&type=script&lang=ts"
export * from "./leave-case-manage-handled.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6ddee8",
  null
  
)

export default component.exports